<script setup lang="ts">
import type { MaterialV1 } from '@ilteducation/content-registry-types';
import { MaterialCover } from '@ilteducation/components';

defineProps<{
  material: MaterialV1;
}>();

const emit = defineEmits<{
  (e: 'click', material: MaterialV1): void;
}>();

const onClick = (material: MaterialV1) => {
  emit('click', material);
};
</script>

<template>
  <div
    class="material-thumbnail"
    role="button"
    tabindex="0"
    :aria-label="material.title"
    @click="onClick(material)"
    @keydown.enter.prevent="onClick(material)"
    @keydown.space.prevent="onClick(material)"
  >
    <MaterialCover class="mb-3" :aspect-ratio="16 / 9" :id="material.id" :is-rounded="false">
      <template #coverFeatures>
        <div class="material-bubble bg-primary">
          <v-icon size="x-small" color="on-primary" icon="fa:fal fa-file-lines"></v-icon>
        </div>
      </template>
    </MaterialCover>
    <div class="material-title text-h5 text-secondary">{{ material.title }}</div>
  </div>
</template>

<style scoped lang="scss">
@use '@/foundations/theme/settings';
@use 'sass:map';

.material-thumbnail {
  position: relative;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid rgb(var(--v-theme-primary));
    outline-offset: 2px;
    border-radius: 4px;
  }
}

.material-title {
  font-size: 0.9375rem !important;
}

.material-bubble {
  position: absolute;
  top: -8px;
  left: -10px;
  z-index: 1;

  @media #{map.get(settings.$display-breakpoints, 'lg-and-up')} {
    top: 10px;
  }

  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  height: 1.75rem;
  width: 1.75rem;

  @media #{map.get(settings.$display-breakpoints, 'md-and-up')} {
    height: 2rem;
    width: 2rem;
  }
}
</style>
